<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-3/4 h-3/4 mx-auto bg-white border rounded-lg"
  >
    <div class="inline-block align-bottom bg-white rounded-lg px-1 pt-6 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:align-middle h-full w-full sm:p-6">
      <div class="block absolute top-4 right-0 pt-4 pr-4">
        <button @click="closeModal()" type="button" class="bg-blue-600 rounded-md text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600">
          <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div class="sm:flex sm:items-start h-full w-full">
        <div class="text-center sm:mt-2 sm:ml-4 sm:text-left h-full w-full">
          <h3 class="pt-2 leading-6 font-medium text-gray-900" id="modal-title">
            {{ header }}
          </h3>
          <div class="mt-2 h-full w-full">
            <iframe class="h-full w-full" :src="url"></iframe>
          </div>
        </div>
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import { VueFinalModal } from 'vue-final-modal'
  import { onMounted, ref } from 'vue'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  let url = computeUrl()
  let header = ref(props.params.header)
  // let widthSetting = window.innerWidth < 600 ? '100%' : '90%'
  // let heightSetting = window.innerHeight > window.innerWidth ? window.innerHeight * 0.9 : window.innerHeight * 0.9

  onMounted(() => {
  })

  function closeModal() {
    emit('close')
  }

  function computeUrl() {
    const hasParams = props.params.url.includes('?')
    return `${props.params.url}${hasParams ? '&' : '?'}hide_chrome=true`
  }
</script>

<style>
  .vm--modal {
    overflow: initial !important;
  }
</style>
